import Button from "@app/sharedComponents/Button/Button";
import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader";
import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from "@app/theme";
import { formatIndianCurrency } from "@app/utils/utility";
import { ScrollView,Image } from "react-native";
import AccordionListItem from "../ConfirmPay/components/AccordionAnimated";
import { Info } from '@app/sharedComponents/Icons/Icons';
import { useEffect, useState } from "react";
import { endpoints } from "@app/api/apis";
import { useAppSelector } from "@app/store/hooks";
import axios from "axios";


const RepayDues = ({navigation})=>{
    const selectedAmount = 400750;
    const foreclosureDetails = useAppSelector((state) => state?.auth?.foreclosureDetails);
    return(
        <>
        <PageHeaders label="Repay dues" pageName="RepayDues" navigation={navigation}/>
        <ScrollView style={{flex:1,backgroundColor:themeColorSet["bg-surface-page"]}}>
        <ThemedView m="lg" mb="sm" flexDirection="row" alignItems="center" px='md' py="sm" borderWidth={1} borderColor="border-primary" borderRadius="sm" backgroundColor="bg-surface-primary" >
            <Image 
                source={{
                    uri:`https://volt-images-alpha.s3.ap-south-1.amazonaws.com/outstanding_icon.png`}} 
                    style={{width:46,height:46}}/>
            <ThemedView ml="md">
                <ThemedText variant="b3s" color="text-primary" >{selectedAmount>0 ? 'You have outstanding dues':'You have excess amount'}</ThemedText>
                <ThemedText variant="b4r" color="text-secondary" >{selectedAmount>0 ?'Please clear your dues to proceed':'Place refund request to proceed'}</ThemedText>
            </ThemedView>
        </ThemedView>
        <ThemedText variant="h3s" color="text-primary" m="lg">Net dues payable</ThemedText>
        <ThemedView backgroundColor="bg-surface-primary" p="lg">
            <AccordionListItem
                    title={'Charges due'}
                    subTitle={'₹'+formatIndianCurrency(100)}
                >
                <ThemedView >
                    <ThemedView  flexDirection="row" justifyContent="space-between" mb="sm" mt="xs">
                        <ThemedText variant="b4r" color="text-primary">
                        Outstanding charges
                        </ThemedText>
                        <ThemedText variant="b4r" color="text-primary">
                            ₹{formatIndianCurrency(200)}
                        </ThemedText>
                    </ThemedView>
                    <ThemedView  flexDirection="row" justifyContent="space-between">
                        <ThemedText variant="b4r" color="text-primary">
                        Total Demat and bounce charged
                        </ThemedText>
                        <ThemedText variant="b4r" color="text-primary">
                            ₹{formatIndianCurrency(300)}
                        </ThemedText>
                    </ThemedView>
                </ThemedView>
            </AccordionListItem>
            <ThemedView width={'100%'} height={1} backgroundColor="border-secondary" mt="lg"/>
            <AccordionListItem
                title={'Interest due'}
                subTitle={'₹'+formatIndianCurrency(400)}
            >
                <ThemedView>
                    <ThemedView  flexDirection="row" justifyContent="space-between" mb="sm" mt="xs">
                        <ThemedText variant="b4r" color="text-primary">
                        Interest accrued not due
                        </ThemedText>
                        <ThemedText variant="b4r" color="text-primary">
                            ₹{formatIndianCurrency(400??0)}
                        </ThemedText>
                    </ThemedView>
                    <ThemedView  flexDirection="row" justifyContent="space-between" mb="sm">
                        <ThemedText variant="b4r" color="text-primary">
                        Advance interest
                        </ThemedText>
                        <ThemedText variant="b4r" color="text-primary">
                            ₹{formatIndianCurrency(400??0)}
                        </ThemedText>
                    </ThemedView>
                    <ThemedView  flexDirection="row" justifyContent="space-between" mb="sm">
                        <ThemedText variant="b4r" color="text-primary">
                        Penal interest accrued not due
                        </ThemedText>
                        <ThemedText variant="b4r" color="text-primary">
                            ₹{formatIndianCurrency(400??0)}
                        </ThemedText>
                    </ThemedView>
                    <ThemedView  flexDirection="row" justifyContent="space-between" mb="sm">
                        <ThemedText variant="b4r" color="text-primary">
                        Penal interest
                        </ThemedText>
                        <ThemedText variant="b4r" color="text-primary">
                            ₹{formatIndianCurrency(400??0)}
                        </ThemedText>
                    </ThemedView>
                </ThemedView>
            </AccordionListItem>
            <ThemedView width={'100%'} height={1} backgroundColor="border-secondary" my="lg"/>
            <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center">
                <ThemedView flexDirection="row" alignItems="center">
                    <ThemedText variant="b3r" color="text-primary">Advance interest</ThemedText>
                    <ThemedPressable>
                            <Info size={16}/>
                    </ThemedPressable>
                </ThemedView>
                <ThemedText variant="b3s" color="text-emphasis-secondary">-₹{formatIndianCurrency(1000)}</ThemedText>
            </ThemedView>
        </ThemedView>

        </ScrollView>
        <ThemedView p="lg" backgroundColor="bg-surface-primary" flexDirection="row" justifyContent="space-between" alignItems="center" borderTopWidth={1} borderColor="border-secondary">
            <ThemedView flex={1}>
                <ThemedText variant="b4m" color="text-secondary">Total dues</ThemedText>
                <ThemedText variant="b2b" color="text-primary">₹{formatIndianCurrency(400750)}</ThemedText>
            </ThemedView>
            <ThemedView flex={2}>
                <Button label="Pay dues" size="MD" handlePress={()=>{}} />
            </ThemedView>
        </ThemedView>
        </>
    )
}
export default RepayDues;